import type {
  RateCalculationTestResponse,
  MegaShipmentProcessCreateResponse,
  RateCalculationTestRequest,
} from '../services/CarrierService/types';

export const adaptMegaMethodResponseToCarrierSelectionResponse = (response: MegaShipmentProcessCreateResponse) => {
  const rateCalculationTestResponse: RateCalculationTestResponse = {
    shipiumShipmentId: response.shipiumShipmentId,
    partnerShipmentId: response.carrierSelection.partnerShipmentId,
    ruleSetUrn: '', // Not available on megamethod
    ruleSetName: '', // Not available on megamethod
    carrierDecision: {
      carrier: response.carrierSelection.carrier,
      status: response.carrierSelection.status || '',
      carrierAccountId: response.carrierSelection.carrierAccountId,
      partnerId: response.carrierSelection.partnerId,
      serviceMethodUrn: response.carrierSelection.serviceMethodUrn,
      serviceMethodName: response.carrierSelection.serviceMethodName,
      carrierServiceName: response.carrierLabel.carrierServiceName || '',
      carrierEstimatedPriceDetails: {
        currencyCode: response.carrierLabel.carrierLabelCurrencyCode,
        totalCost: response.carrierSelection.totalCost,
        shippingCost: response.carrierSelection.totalCost,
        insuranceCost: 0,
        accessorials: 0,
        duty: 0,
        taxes: 0,
      },
      details: {
        calculatedRates: [],
        zonesByCarrier: {},
        serviceMethodsAfterFiltering: [],
        availableServiceMethods: [],
        requestParams: {
          currencyCode: response.carrierLabel.carrierLabelCurrencyCode,
          shipmentShipDate: response.shippedDateTime,
          packagingType: response.packagingType,
        },
      },
    },
    carrierSelectionDateTime: response.carrierSelection.carrierSelectionDateTime,
    shipmentShipDate: response.shippedDateTime,
    carrierSelectionId: response.carrierSelection.carrierSelectionId,
    carrierSelectionExpiration: '', // Not available on megamethod
    labelVoided: response.labelVoided || false,
    carrierLabel: response.carrierLabel,
    requestBody: response.requestBody,
    responseBody: response.responseBody,
    duration: response.duration,
    carrierSelection: response.carrierSelection,
    partnerThirdPartyBillingSetId: response.partnerThirdPartyBillingSetId,
    forceThirdPartyBilling: response.forceThirdPartyBilling,
    requestThirdPartyBillingSetId: response.requestThirdPartyBillingSetId,
  };

  return rateCalculationTestResponse;
};

export const adaptRateCalculationTestRequestToMegaMethodPayload = (request: RateCalculationTestRequest) => {
  return {
    currencyCode: 'usd',
    generateLabel: request.generateLabel,
    labelParameters: {
      currencyCode: 'usd',
      customLabelEntries: request.customLabelEntries || [],
      testMode: !(request.testMode === false),
      includeLabelImagesInResponse: true,
      labelFormats: ['png', 'zpl'],
      manifest: false,
    },
    shipmentParameters: {
      fulfillmentContext: request.fulfillmentContext,
      businessDaysOfTransit: request.businessDaysOfTransit,
      saturdayDelivery: request.saturdayDelivery,
      deliverySignatureOption: request.deliverySignatureOption,
      referenceIdentifier: request.referenceIdentifier,
      purchaseOrderIdentifier: request.purchaseOrderIdentifier,
      shipOption: request.shipOption,
      shipmentTags: [...(request.shipmentTags ? request.shipmentTags : []), 'test'],
      shippedDateTime: request.shipmentEffectiveDate || new Date().toISOString(),
      orderedDateTime: request.shipmentEffectiveDate || new Date().toISOString(),
      customsInfo: {
        customsDescription: request?.customsInfo?.customsDescription,
        totalCustomsValue: request?.customsInfo?.totalCustomsValue,
        totalCustomsValueCurrency: request?.customsInfo?.totalCustomsValueCurrency,
      },
      destinationAddress: {
        addressType: request.shipmentDestinationAddress?.addressType,
        city: request.shipmentDestinationAddress?.city,
        phoneNumber: request.shipmentDestinationAddress?.phoneNumber,
        state: request.shipmentDestinationAddress?.state,
        postalCode: request.shipmentDestinationAddress?.postalCode,
        company: request.shipmentDestinationAddress?.companyName || 'N/A',
        name: request.shipmentDestinationAddress?.name || 'N/A',
        street1: request.shipmentDestinationAddress?.address1,
        street2: request.shipmentDestinationAddress?.address2,
        countryCode: request.shipmentDestinationAddress?.country,
      },
      shipFromAddress: {
        addressType: request.shipmentSourceAddress?.addressType,
        city: request.shipmentSourceAddress?.city,
        phoneNumber: request.shipmentSourceAddress?.phoneNumber,
        state: request.shipmentSourceAddress?.state,
        postalCode: request.shipmentSourceAddress?.postalCode,
        company: request.shipmentSourceAddress?.companyName || 'N/A',
        name: request.shipmentSourceAddress?.name || 'N/A',
        street1: request.shipmentSourceAddress?.address1,
        street2: request.shipmentSourceAddress?.address2,
        countryCode: request.shipmentSourceAddress?.country,
      },
      orderItemQuantities: [
        {
          productDetails: request.unsupportedProductDetails || [],
          productId: '123456',
          quantity: 1,
          hazmat: request.hazmatParams?.hazmat,
          hazmatInfo: {
            ...(request.hazmatParams || {}),
          },
        },
      ],
      packagingType: {
        packagingMaterial: request.packagingMaterial,
        packagingSizeName: 'test-package',
        packagingWeight: {
          weight: request.packageWeight?.weight,
          weightUnit: request.packageWeight?.weightUnit,
        },
        linearDimensions: {
          ...request.packagelinearDimensions,
        },
      },
      totalWeight: request.packageWeight,
    },
  };
};
